/* eslint-disable no-shadow */

const SELECTED_OU_STORAGE_KEY = 'selectedOU';

const getStoredOUId = () => {
  try {
    const stored = sessionStorage.getItem(SELECTED_OU_STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  } catch {
    return null;
  }
};

const storeOUId = (ou) => {
  try {
    if (ou?.id) {
      sessionStorage.setItem(SELECTED_OU_STORAGE_KEY, JSON.stringify(ou.id));
    } else {
      sessionStorage.removeItem(SELECTED_OU_STORAGE_KEY);
    }
  } catch {
    // ignore
  }
};

const state = () => ({
  selectedOU: null,
  storedOUId: getStoredOUId(),
});

const getters = {};

const mutations = {
  SET_SELECTED_OU(state, payload) {
    state.selectedOU = payload;
    storeOUId(payload);
  },
  SET_STORED_OU_ID(state, payload) {
    state.storedOUId = payload;
  },
};

const actions = {};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
